import { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';

import isEmail from 'Lib/utilities/isEmail';

const components = {
    DropdownIndicator: null
};

class EmailChipInput extends Component {
    state = {
        inputValue: '',
        value: []
    };

    componentDidMount() {
        if (Array.isArray(this.props.value)) {
            const value = [];
            this.props.value.forEach(item => {
                if (typeof item == 'string') {
                    value.push(this.createOption(item));
                } else if (typeof item == 'object') {
                    value.push(item);
                }
            });
            this.setState({ value });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.value != this.state.value) {
            if (this.props.onChange) {
                this.props.onChange(this.state.value);
            }
        }
    }

    handleChange = value => {
        if (!value) {
            value = [];
        }
        this.setState({ value });
    };

    handleInputChange = inputValue => {
        this.setState({ inputValue });
    };

    handleKeyDown = event => {
        const { inputValue, value = [] } = this.state;

        if (!inputValue) {
            return;
        }

        switch (event.key) {
            case 'Enter':
            case 'Tab':
                if (isEmail(inputValue)) {
                    this.setState({
                        inputValue: '',
                        value: [...value, this.createOption(inputValue)]
                    });
                }
                event.preventDefault();
        }
    };

    handleBlur = () => {
        const { inputValue, value = [] } = this.state;

        if (!inputValue) {
            return;
        }

        if (isEmail(inputValue)) {
            this.setState({
                inputValue: '',
                value: [...value, this.createOption(inputValue)]
            });
        }
    };

    createOption = label => {
        if (this.props.createOption) {
            return this.props.createOption(label);
        }

        return {
            label: label,
            value: label
        };
    };

    render() {
        const { inputValue, value } = this.state;
        const { isClearable = true, isMulti = true, placeholder = 'Type an email address', className, ...rest } = this.props;

        return (
            <CreatableSelect
                {...rest}
                // // className={classnames('rv-select', className)}
                // classNamePrefix="rv-select"
                components={components}
                inputValue={inputValue}
                isClearable={isClearable}
                isMulti={isMulti}
                menuIsOpen={false}
                onChange={this.handleChange}
                onInputChange={this.handleInputChange}
                onKeyDown={this.handleKeyDown}
                onBlur={this.handleBlur}
                placeholder={placeholder}
                value={value}
            />
        );
    }
}

EmailChipInput.propTypes = {
    value: PropTypes.array
};

export default EmailChipInput;
